/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import DeploymentLogs from "../components/DeploymentLogs.jsx";
import TextElement from "../components/TextElement.jsx";
import useDeployment from "../hooks/useDeployment.jsx";

function DeploymentPage({deploymentId}) {
    const deploymentInfo = useDeployment(deploymentId)

    return (
        <div className={"mt-4 space-y-4"}>
            <TextElement textType={"header-xl"}>
                Current Deployment: {deploymentInfo?.userInput?.name ?? deploymentId}
            </TextElement>

            <DeploymentLogs deploymentId={deploymentId}/>

        </div>
    );
}

DeploymentPage.propTypes = {};

DeploymentPage.defaultProps = {};


export default DeploymentPage;